import type { FC } from 'react';
import React from 'react';
import type { RouteProps } from 'react-router-dom';
import { Route } from 'react-router-dom';

import { UserRole } from '@/api-gen/api.schemas';
import type { AccessOptions } from 'app/utils/useHasAccess.ts';
import useHasAccess from 'app/utils/useHasAccess.ts';
import MainLogged from 'app/components/MainLogged.tsx';
import { FallbackPage } from 'app/components/FallbackPage/index.tsx';
import { useIsHeiDomain } from 'app/hooks/useIsHeiDomain';

export interface ProtectedRouteProps extends RouteProps, AccessOptions {
  /** Route path (kept for clarity) */
  path: string | string[];
}

/**
 * Wrapper that checks whether the current user is authorised to view the
 * route.  It supports:
 * • role whitelists                  – every existing route keeps working
 * • allowInterpreter (flag)          – OR with role check
 * • requireSklls (flag)              – AND after primary check
 */
const ProtectedRoute: FC<ProtectedRouteProps> = ({ roles, allowInterpreter = false, requireSklls = true, ...rest }) => {
  const hasAccess = useHasAccess({ roles, allowInterpreter, requireSklls });
  const isHeiDomain = useIsHeiDomain();
  if (!hasAccess) {
    return <FallbackPage text="No access" autoGenerateDiagnosticId />;
  }

  return (
    <MainLogged>
      <Route {...rest} />
    </MainLogged>
  );
};

export default ProtectedRoute;
